<template>
    <div class="panel"  v-if="files.length > 0">
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Супровідні файли
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip"
                        data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip"
                        data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            <div class="panel-content">
                <BTable key="tender_files" striped :items="tender.files" :fields="fileds">
                    <template v-slot:cell(get_row)="row">
                        <div class='icon-stack cursor-pointer fs-xxl' v-on:click="getFile(row.item)">
                            <i class="base base-1 icon-stack-3x opacity-100 color-primary-600"></i>
                            <i class="far fa-save icon-stack-1x opacity-100 color-white"></i>
                        </div>
                    </template>
                </BTable>
            </div>
        </div>
    </div>
</template>

<script>

import {
    BTable,
} from 'bootstrap-vue-next';

export default {
    name: "tender_files",
    props: {
        tender: {
            type: Object,
            required: true
        }
    },
    components: {
        BTable
    },
    
    methods: {
        getFile(file) {
            console.log(file);
            window.location.href = '/internal/media/file/' + file.file_id;
        }
    },
    
    computed: {
        fileds() {
            return [
                {key: 'file.name', label: 'Файл'},
                {key: 'description', label: 'Примітка'},
                {key: 'get_row', label: 'Зберегти',}
            ];
        },
        
        files () {
            return this.tender?.files || [];
        }
    }
}
</script>


<style scoped>

</style>